(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lus-cart-installation-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luscentra-installation-request')) {
    class LuscentraInstallationRequest extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('[data-installation-request-checkbox]');
        this.status = this.querySelector('[data-installation-request-status]');
        this.checkbox?.addEventListener('change', (event) => {
          event.stopPropagation();
          this.updateRequest();
        });

        const hasStarterKit = this.dataset.hasStarterKit === 'true';
        const selected = this.dataset.selected === 'true';
        const modelsChanged = this.dataset.models !== this.dataset.storedModels;
        const itemsChanged = this.dataset.items !== this.dataset.storedItems;

        if (selected && (!hasStarterKit || modelsChanged || itemsChanged)) {
          this.persistRequest(hasStarterKit).catch(() => {});
        }
      }

      async updateRequest() {
        const requested = this.checkbox.checked;
        const previous = this.dataset.selected === 'true';
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = '';

        try {
          await this.persistRequest(requested);
          this.status.textContent = requested
            ? this.dataset.selectedMessage
            : this.dataset.clearedMessage;
        } catch (error) {
          this.checkbox.checked = previous;
          this.status.textContent = this.dataset.errorMessage;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }

      async persistRequest(requested) {
        if (!window.luscentraInstallationRequestUpdate) {
          const source = this;
          const root = window.Shopify?.routes?.root || '/';
          const attributes = {
            'Free installation requested': requested ? (source.checkbox?.value || 'Yes') : null,
            'Installation kit models': requested ? source.dataset.models : null,
            'Installation kit items': requested ? source.dataset.items : null
          };

          window.luscentraInstallationRequestUpdate = fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ attributes })
          }).then((response) => {
            if (!response.ok) throw new Error('Cart update failed');
            return response.json();
          }).finally(() => {
            window.luscentraInstallationRequestUpdate = null;
          });
        }

        await window.luscentraInstallationRequestUpdate;
        document.querySelectorAll('luscentra-installation-request').forEach((request) => {
          request.dataset.selected = String(requested);
          request.dataset.storedModels = requested ? request.dataset.models : '';
          request.dataset.storedItems = requested ? request.dataset.items : '';
          const checkbox = request.querySelector('[data-installation-request-checkbox]');
          if (checkbox) checkbox.checked = requested;
        });
      }
    }

    customElements.define('luscentra-installation-request', LuscentraInstallationRequest);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lus-cookie-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.querySelector('[data-lus-cookie-notice]');
    if (!notice) return;

    const storageKey = 'luscentra_cookie_notice_seen_v2';
    const cookieName = 'luscentra_cookie_notice_seen';
    const dismissButton = notice.querySelector('[data-lus-cookie-dismiss]');
    let dismissed = false;

    const cookieWasSet = () => document.cookie
      .split('; ')
      .some((part) => part.startsWith(`${cookieName}=`));

    const hasBeenSeen = () => {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (error) {
        return cookieWasSet();
      }
    };

    const markAsSeen = () => {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (error) {
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `${cookieName}=1; Max-Age=31536000; Path=/; SameSite=Lax${secure}`;
      }
    };

    const syncBottomOffset = () => {
      const selectors = [
        '.lus-pdp__sticky[data-lus-ready]:not([hidden])',
        '.lus-home-sticky-shop:not([hidden])',
        '.lus-wq__sticky:not([hidden])'
      ];
      let offset = window.matchMedia('(max-width: 749px)').matches ? 12 : 16;

      selectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (!element) return;
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        if (style.visibility === 'hidden' || Number(style.opacity) === 0 || rect.height === 0) return;
        if (rect.bottom >= window.innerHeight - 2) {
          offset = Math.max(offset, Math.ceil(window.innerHeight - rect.top + 12));
        }
      });

      notice.style.setProperty('--lus-cookie-bottom', `${offset}px`);
    };

    const dismiss = () => {
      if (dismissed) return;
      dismissed = true;
      markAsSeen();
      notice.classList.remove('is-visible');
      notice.classList.add('is-leaving');
      document.body.classList.remove('lus-cookie-notice-open');
      window.setTimeout(() => {
        notice.hidden = true;
      }, 300);
    };

    if (hasBeenSeen()) return;

    markAsSeen();
    syncBottomOffset();
    notice.hidden = false;
    document.body.classList.add('lus-cookie-notice-open');
    window.requestAnimationFrame(() => notice.classList.add('is-visible'));

    dismissButton?.addEventListener('click', dismiss);
    window.addEventListener('resize', syncBottomOffset, { passive: true });
    window.setTimeout(syncBottomOffset, 400);
    window.addEventListener('scroll', () => {
      const threshold = Math.max(40, window.innerHeight * 0.08);
      if (window.scrollY > threshold) dismiss();
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
